import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';

import { Flex, Span } from '@sopranodesign/pulse-components';

const MessageBubble = styled.div`
  ${tw`rounded px-3 py-2 text-sm`}
  max-width: 85%;
  word-break: break-word;
  white-space: pre-wrap;
  background: ${({ role, theme }) =>
    role === 'user'
      ? theme.primary
        ? theme.primary
        : '#6366F1'
      : '#F3F4F6'};
  color: ${({ role }) => (role === 'user' ? '#fff' : '#111827')};
  align-self: ${({ role }) => (role === 'user' ? 'flex-end' : 'flex-start')};
`;

const RoleLabel = styled(Span)`
  ${tw`text-xs`}
  align-self: ${({ role }) => (role === 'user' ? 'flex-end' : 'flex-start')};
`;

const ScrollArea = styled.div`
  ${tw`overflow-y-auto flex flex-col`}
  flex: 1;
  min-height: 0;
`;

const AssistantMessageList = ({ messages }) => {
  const bottomRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  if (!messages.length) {
    return (
      <ScrollArea>
        <Flex fat="true" center style={{ flex: 1, padding: '1rem' }}>
          <Span colour="grey" tinyText>
            Describe what you would like to build or change in this workflow.
          </Span>
        </Flex>
      </ScrollArea>
    );
  }

  return (
    <ScrollArea>
      <Flex col ySpace style={{ padding: '0.75rem' }}>
        {messages.map(message => (
          <Flex key={message.id} col ySpaceSm>
            <RoleLabel role={message.role} colour="grey">
              {message.role === 'user' ? 'You' : 'Assistant'}
            </RoleLabel>
            <MessageBubble role={message.role}>{message.content}</MessageBubble>
          </Flex>
        ))}
      </Flex>
      <div ref={bottomRef} />
    </ScrollArea>
  );
};

AssistantMessageList.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      role: PropTypes.oneOf(['user', 'assistant']).isRequired,
      content: PropTypes.string.isRequired
    })
  ).isRequired
};

export default AssistantMessageList;
